import React from 'react';
import LogoImage from './images/logo_flower.png';

const LogoBox = () => (
    <div className="logo-box">
        <img className="logo-image" src={LogoImage} alt="个人导航主页" />
    </div>
);

export default LogoBox;
